import { Box, Button, Typography } from "@mui/material";
import React from "react";
import PagesIcon from "@mui/icons-material/Pages";
import { useNavigate } from "react-router-dom";
const NoSubscribe = () => {
  const navigate = useNavigate();
  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      justifyContent={"center"}
      alignItems={"center"}
      width={"100%"}
      p={2}
      gap={2}
    >
      <PagesIcon sx={{ fontSize: 60, color: "#f44336" }} />
      <Typography textAlign={"center"} variant="h5" fontWeight={600}>
        {" "}
        You need to buy Subscription to use this feature.
      </Typography>

      <Button
        variant="outlined"
        color="error"
        onClick={() => navigate("/auth/subscribe")}
      >
        Buy Subscription
      </Button>
    </Box>
  );
};

export default NoSubscribe;
